import { Feature } from "ol";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import GeoJSON from 'ol/format/GeoJSON';
import MyMap from "../Views/MyMap";
import Style from 'ol/style/Style'
import Fill from 'ol/style/Fill'
import Stroke from 'ol/style/Stroke'
import { Circle, Image } from 'ol/style';
import Polyline from 'ol/format/Polyline';
import { Point } from "ol/geom";
import { styled } from "@material-ui/core";

export const tempLayer = new VectorLayer({
    name: 'temp',
    desc: 'tool',
    visible: true,
    zIndex: 15,
    style: new Style({
        stroke: new Stroke({
            color: 'blue',
            width: 5,
        }),
        fill: new Fill({
            color: 'rgba(255,255,255,0.2)',
        }),
    }),
    source: new VectorSource({
    }),
})

export const addFeatureFromGeojson = (geojson, mapkey) => {
    if (geojson == undefined) {
        return
    }
    if (geojson == null) {
        return
    }
    let feature = new Feature({
        geometry: new GeoJSON().readFeature(geojson).getGeometry()
    });
    if (mapkey != undefined) {
        feature.set('mapkey', mapkey)
    }
    feature.setStyle(styled(feature.getGeometry().getType()))
    tempLayer.getSource().addFeature(feature)
}
export const showGeojson = (geojson) => {

    console.log("asdasdasdasdasdasdsdasd", geojson)
    if (geojson == null || geojson == undefined) {

        return
    }

    let feature = new Feature({
        geometry: new GeoJSON().readFeature(geojson).getGeometry()
    })
    console.log(feature.getGeometry().getExtent(), "")
    MyMap.getView().fit(feature.getGeometry().getExtent(), { "maxZoom": 19, "duration": 1500 })
}
export const showGeojsonnew = (geojson) => {

    if (geojson === null || geojson === undefined) {
        alert('Geometri bulunamadı.')
        return
    }
    tempLayer.getSource().clear()
    console.log(window.location.href)

    let feature = new Feature({ geometry: new GeoJSON().readFeature(geojson).getGeometry() })

    tempLayer.getSource().addFeature(feature)
    // if (feature.getGeometry().getType() === 'Point') {
    //     feature.setStyle(styled('Point'))
    // }
    MyMap.getView().fit(feature.getGeometry().getExtent(), { "maxZoom": 20, "duration": 1300 });
}

export const kapiStyle = new Style({
    image: new Circle({
        radius: 5,
        fill: new Fill({
            color: 'blue',
        }),
        stroke: new Stroke({
            color: 'white',
            width: 3,
        }),
    }),
    zIndex: Infinity,

})

export const markerColorStyle = (color) => {
    return [new Style({
        image: new Circle({
            radius: 10,
            fill: new Fill({
                color: color,
            }),
            stroke: new Stroke({
                color: 'white',
                width: 5,
            }),
        }),
        zIndex: Infinity,

    })]
}

export const zoomToGeojson = (geojson, show) => {

    tempLayer.getSource().clear()
    let feature = new Feature({
        geometry: new GeoJSON().readFeature(geojson).getGeometry()
    });
    if (show) {
        tempLayer.getSource().addFeature(feature)
    }
    MyMap.getView().fit(feature.getGeometry().getExtent(), { "maxZoom": 20.5, "duration": 1500 })
}

export const zoomToEncodedPolyline = (polyline, show) => {
    tempLayer.getSource().clear()
    let feature = new Feature({
        geometry: new Polyline().readGeometry(polyline)
    });
    tempLayer.getSource().addFeature(feature)

    MyMap.getView().fit(feature.getGeometry().getExtent(), { "maxZoom": 15, "duration": 1500 })
    console.log(tempLayer.getSource().getFeatures())
}

export const zoomToYapiAdres = (geo1, geo2) => {
    console.log(geo1, "geo1", geo2)
    tempLayer.getSource().clear()
    let feature = new Feature({
        geometry: new GeoJSON().readFeature(geo1).getGeometry()
    });
    tempLayer.getSource().addFeature(feature)
    feature.setStyle(kapiStyle)
    MyMap.getView().fit(feature.getGeometry().getExtent(), { "maxZoom": 20.5, "duration": 1500 })
    if (geo2 !== null) {
        let feature = new Feature({
            geometry: new GeoJSON().readFeature(geo2).getGeometry()
        });
        tempLayer.getSource().addFeature(feature)
    }
}

export const addMarkerWithColor = (lon, lat, color) => {
    let feature = new Feature({
        geometry: new Point([lat, lon])
    });
    tempLayer.getSource().addFeature(feature)
    feature.setStyle(markerColorStyle(color))
}